import { Component, AfterViewInit } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CountryPhoneCodes } from '@app/components/interface/country-phone-codes';
import { AddressService } from '@app/services/address.service';
import { AuthServiceService } from '@app/services/auth-service.service';
import { DialogService } from '@app/services/dialog.service';
import { ToastService } from '@app/services/toast.service';
import { WarehouseService } from '@app/services/warehouse.service';
import { BreadcrumbService } from '@app/services/breadcrumb.service';
import { Observable } from 'rxjs';
import { AddAddressListingComponent } from '../add-address-listing/add-address-listing.component';

interface WarehouseFormData {
  warehouseName: string;
  companyAddress: string;
  contactName: string;
  email: string;
  countryCode: string;
  phone: string;
  altPhone: string;
}
@Component({
  selector: 'app-warehouse-add',
  templateUrl: './warehouse-add.component.html',
  styleUrl: './warehouse-add.component.scss'
})
export class WarehouseAddComponent implements AfterViewInit {
  warehouseForm: WarehouseFormData = {
    warehouseName: '',
    companyAddress: '',
    contactName: '',
    email: '',
    countryCode: '+91',
    phone: '',
    altPhone: ''
  };

  private initialFormState: string = '';

  errors: { [key: string]: string } = {};
  loading = false;

  addresses: string[] = [
    '123 Main St, Toronto, ON M5V 1A1',
    '456 Oak Ave, Vancouver, BC V6B 2K9',
    '789 Pine Rd, Montreal, QC H3A 1A1',
    '321 Elm St, Calgary, AB T2P 1K3'
  ];

  filteredAddresses: string[] = [];
  showDropdown = false;
  hideTimeout: any;
  id: Number;
  countryCodes = CountryPhoneCodes;
  warehouse$!: Observable<object[]>;
  is_main_localation: string = 'false';
  constructor(private router: Router, private dialogService: DialogService, private addressService: AddressService, public warehouseService: WarehouseService, public authService: AuthServiceService, private toast: ToastService, private route: ActivatedRoute, public dialog: MatDialog, private shareddta: ShareddtaService, private breadcrumbService: BreadcrumbService) {
    this.id = this.route.snapshot.params['id'];
    this.isAddMode = !this.id;
    const savedCountryCode = localStorage.getItem('countryCode');
    if (savedCountryCode) {
      this.warehouseForm.countryCode = savedCountryCode;
    }
    if (this.isAddMode) {
      this.initialFormState = JSON.stringify(this.warehouseForm);
    }
    if (!this.isAddMode) {
      this.warehouseService.warehouseDetails(this.id);
      this.warehouse$ = this.warehouseService.getWarehouse();

      this.warehouse$.subscribe((data: any) => {
        this.addressId = data?.result?.address?.id
        this.warehouseForm.warehouseName = data?.result?.warehouse_name;
        this.warehouseForm.companyAddress = data?.result?.address?.address;
        this.warehouseForm.contactName = data?.result?.contact_name;
        this.warehouseForm.email = data?.result?.email;
        this.warehouseForm.countryCode = data.result?.country_code;
        this.warehouseForm.phone = data?.result?.phone;
        this.warehouseForm.altPhone =
          data?.result?.alt_phone && data.result.alt_phone !== 'null'
            ? data.result.alt_phone
            : '';

        this.is_main_localation = data?.result?.is_main_localation
        this.initialFormState = JSON.stringify(this.warehouseForm);
      });
    }
  }

  ngOnInit(): void {
    this.breadcrumbService.clear();
  }

  ngAfterViewInit(): void {
    this.shareddta.signalPageReady();
  }

  capitalizeInput(field: keyof WarehouseFormData): void {
    const value = this.warehouseForm[field] as string;
    this.warehouseForm[field] = value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ') as any;
  }

  onPhoneInput(field: 'phone' | 'altPhone'): void {
    if (this.warehouseForm[field]) {
      this.warehouseForm[field] = this.warehouseForm[field].replace(/[^0-9]/g, '');
    }
  }

  keyPressNumbers(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  filterAddresses(): void {
    const searchTerm = this.warehouseForm.companyAddress.toLowerCase();
    this.addressList(1, searchTerm);
    this.showDropdown = true;
  }
  addressId: any;
  selectAddress(address: any): void {
    this.warehouseForm.companyAddress = address.address;
    this.addressId = address.id
    this.showDropdown = false;
  }

  hideDropdownDelayed(): void {
    this.hideTimeout = setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }

  addAddress(): void {
    this.router.navigate(['/admin/address/add']);
  }

  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  validateForm(): boolean {
    this.errors = {};
    let isValid = true;

    if (!this.warehouseForm.warehouseName.trim()) {
      this.errors['warehouseName'] = 'Warehouse Name is required';
      isValid = false;
    }

    if (!this.warehouseForm.companyAddress.trim()) {
      this.errors['companyAddress'] = 'Company Address is required';
      isValid = false;
    }

    if (!this.warehouseForm.contactName.trim()) {
      this.errors['contactName'] = 'Contact Name is required';
      isValid = false;
    }

    if (!this.warehouseForm.email.trim()) {
      this.errors['email'] = 'Email is required';
      isValid = false;
    } else if (!this.validateEmail(this.warehouseForm.email)) {
      this.errors['email'] = 'Please enter a valid email address';
      isValid = false;
    }

    if (!this.warehouseForm.phone.trim()) {
      this.errors['phone'] = 'Phone is required';
      isValid = false;
    } else if (this.warehouseForm.phone.length !== 10) {
      this.errors['phone'] = 'Phone must be 10 digits';
      isValid = false;
    }

    if (this.warehouseForm.altPhone && this.warehouseForm.altPhone.length !== 10) {
      this.errors['altPhone'] = 'Alternate Phone must be 10 digits';
      isValid = false;
    }

    return isValid;
  }
  isAddMode: boolean = true;
  submitWarehouse(): void {
    if (!this.validateForm()) {
      return;
    }
    this.loading = true;
    const formData = new FormData();
    formData.append('warehouse_name', this.warehouseForm.warehouseName);
    formData.append('address', this.addressId);
    formData.append('contact_name', this.warehouseForm.contactName);
    formData.append('email', this.warehouseForm.email);
    formData.append('phone', this.warehouseForm.phone);
    formData.append('alt_phone', this.warehouseForm.altPhone);
    formData.append('country_code', this.warehouseForm.countryCode);
    if (this.isAddMode) {
      formData.append('is_main_localation', 'false');
    }
    if (!this.isAddMode) {
      formData.append('is_main_localation', this.is_main_localation);
    }
    if (this.isAddMode) {
      this.warehouseService.warehouseAdd(formData).subscribe(
        (data: any) => {
          this.loading = false;
          if (this.authService.resultCodeError(data)) {
            return;
          }

          this.toast.show('success', data.resultDescription);
          this.router.navigate([
            '/' + this.authService._isRoleName + '/warehouse',
          ]);
        },
        (error) => {
          this.loading = false;
          this.authService.dataError(error);
        }
      );
    } else {
      this.warehouseService.warehouseEdit(this.id, formData).subscribe(
        (data: any) => {
          this.loading = false;
          if (this.authService.resultCodeError(data)) {
            return;
          }
          this.toast.show('success', data.resultDescription);
          this.router.navigate([
            '/' + this.authService._isRoleName + '/warehouse',
          ]);
        },
        (error) => {
          this.loading = false;
          this.authService.dataError(error);
        }
      );
    }

    // Here you would typically call your API service
    // this.warehouseService.addWarehouse(this.warehouseForm).subscribe(...)
  }

  // cancel(): void {
  //   if (confirm('Are you sure you want to cancel? Any unsaved changes will be lost.')) {
  //     this.resetForm();
  //   }
  // }
  goToDashboard(): void {
    this.router.navigate(['/admin/dashboard']);
  }

  async cancel(): Promise<void> {
    const currentFormState = JSON.stringify(this.warehouseForm);
    
    if (currentFormState === this.initialFormState) {
      this.router.navigate(['/admin/warehouse']);
      return;
    }

    const confirmed = await this.dialogService.confirm(
      'Discard Changes',
      'Are you sure you want to cancel? Any unsaved changes will be lost.'
    );

    if (confirmed.confirmed) {
      this.router.navigate(['/admin/warehouse']);
    }
  }
  resetForm(): void {
    this.warehouseForm = {
      warehouseName: '',
      companyAddress: '',
      contactName: '',
      email: '',
      countryCode: '+1',
      phone: '',
      altPhone: ''
    };
    this.errors = {};
  }

  async goBack(): Promise<void> {
    const currentFormState = JSON.stringify(this.warehouseForm);

    if (currentFormState === this.initialFormState) {
      window.history.back();
      return;
    }

    const confirmed = await this.dialogService.confirm(
      'Discard Changes',
      'Are you sure you want to cancel? Any unsaved changes will be lost.'
    );

    if (confirmed.confirmed) {
      window.history.back();
    }
  }
  address$!: Observable<object[]>;
  addressData: any[] = []; // initialize as empty array
  addressDataCount: number = 0;
  addressList(page?: number, search_text?: string) {
    this.addressService.addressSearch(page, search_text);
    this.address$ = this.addressService.getAddress();

    this.address$.subscribe((data: any) => {
      this.addressData = data?.result?.results;
      this.addressDataCount = data?.result?.count;
    });
  }
  addaddressList(page?: number, search_text?: string) {
    this.addressService.addressSearch(page, search_text);
    this.address$ = this.addressService.getAddress();

    this.address$.subscribe((data: any) => {
      this.addressData = data?.result?.results;
      this.addressDataCount = data?.result?.count;
      this.warehouseForm.companyAddress = this.addressData[0].address
      this.addressId = this.addressData[0].id;
    });
  }
  openDialog(
    enterAnimationDuration: string,
    exitAnimationDuration: string,
  ): void {
    const dialogRef = this.dialog.open(AddAddressListingComponent, {
      width: '800px',
      enterAnimationDuration,
      exitAnimationDuration,
      data: {
        isCloseBtn: true
      },
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.addaddressList(1);
      }
    });
  }
}
